import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'
import ReactDOM from 'react-dom/client'
import App from './App'

if (import.meta.env.VITE_DD_RUM_ENABLED === 'true') {
  datadogRum.init({
    applicationId: import.meta.env.VITE_DD_RUM_APP_ID ?? '',
    clientToken: import.meta.env.VITE_DD_RUM_CLIENT_TOKEN ?? '',
    site: 'datadoghq.com',
    service: 'webaruba-portal',
    env: import.meta.env.VITE_DD_ENV ?? 'production',
    version: import.meta.env.VITE_APP_VERSION ?? '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [
      { match: (url: string) => { const apiUrl = import.meta.env.VITE_API_URL; return apiUrl ? url.startsWith(apiUrl) : false }, propagatorTypes: ['datadog'] }
    ],
    plugins: [reactPlugin({ router: false })]
  })
  datadogRum.startSessionReplayRecording()
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(<App />)
